"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberOfLikelyPushedCalls = void 0;
const get_number_of_groups_in_list_1 = require("../../../../utilities/data-structure-utils.ts/get-number-of-groups-in-list");
const was_likely_part_of_a_pushed_call_1 = require("./was-likely-part-of-a-pushed-call");
function getNumberOfLikelyPushedCalls(items) {
    return (0, get_number_of_groups_in_list_1.getNumberOfGroupsInList)(items, was_likely_part_of_a_pushed_call_1.wasLikelyPartOfAPushedCall);
}
exports.getNumberOfLikelyPushedCalls = getNumberOfLikelyPushedCalls;
